import { Decimal } from 'decimal.js';

interface FormatUsdCurrencyOptions {
  includeSymbol?: boolean;
}

export function formatUsdCurrency(
  value: number | string | null | undefined,
  options?: FormatUsdCurrencyOptions
): string {
  const safeValue =
    value === null || value === undefined
      ? new Decimal(0)
      : new Decimal(value);

  const formatter = new Intl.NumberFormat('en-US', {
    style: options?.includeSymbol === false ? 'decimal' : 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return formatter.format(safeValue.toNumber()).replace(/\.00$/, '');
}
